import { render, staticRenderFns } from "./newspaperContent.vue?vue&type=template&id=678cd0a9&scoped=true&"
import script from "./newspaperContent.vue?vue&type=script&lang=js&"
export * from "./newspaperContent.vue?vue&type=script&lang=js&"
import style0 from "./newspaperContent.vue?vue&type=style&index=0&id=678cd0a9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678cd0a9",
  null
  
)

export default component.exports